/**
 * =========================================================================================
 * Component - Popup
 * =========================================================================================
 **/

import React, {useEffect, useRef} from 'react';

// Packages
import Popup from 'reactjs-popup'; /* Reactjs popup */

const UPopup = (props) => {

    const popupRef = useRef(null);

    useEffect(() => {
        document.querySelector('.u_layout')?.addEventListener('wheel', handleWheel, {passive: true});

        return () => document.querySelector('.u_layout')?.removeEventListener("wheel", handleWheel);
    }, []);

    const handleWheel = (e) => {
        if (popupRef?.current) popupRef?.current?.close();
    }

    useEffect(() => {
        if (props?.showDefault) popupRef?.current?.open();
    }, [props?.showDefault]);

    useEffect(() => {
        if (!props?.open) {
            popupRef?.current?.close();
        }
        props?.close?.();
    }, [props?.open]);

    // Close popup on inner child click
    useEffect(() => {
        if (popupRef.current) popupRef.current.close();
        props?.closeMenuOpen?.();
    }, [props?.closeMenu]);

    return (
        <React.Fragment>
            <Popup
                ref={popupRef}
                trigger={open => (props?.children)}
                arrow={true}
                on={['hover', 'focus']}
                position="bottom center"
                closeOnDocumentClick
                repositionOnResize
                keepTooltipInside={true}
                {...props?.params}
            >
                {props?.desc}
            </Popup>
        </React.Fragment>
    );
}

export default UPopup;
